import React from 'react';
import T from 'prop-types';
import { Form, Input } from 'antd';

import * as validators from '../../../../constants/validators';
import FormItem from '../../../formItem';

import { StyledCard, StyledButton } from './style';

const formName = 'userForm';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 19 },
  },
};

class UserFormCard extends React.PureComponent {
  onFinish = (v) => {
    this.props.updateInfo(v);
  };

  render() {
    const { firstName, lastName, email, loading } = this.props;

    return (
      <StyledCard bordered={false} title="Personal details">
        <Form initialValues={{ firstName, lastName }} name={formName} onFinish={this.onFinish} {...formItemLayout}>
          <FormItem label="E-mail">{email}</FormItem>
          <FormItem label="First name" name="firstName" {...validators.firstName}>
            <Input />
          </FormItem>
          <FormItem label="Last name" name="lastName" {...validators.lastName}>
            <Input />
          </FormItem>

          <StyledButton htmlType="submit" loading={loading} type="primary">
            Save
          </StyledButton>
        </Form>
      </StyledCard>
    );
  }
}

UserFormCard.propTypes = {
  updateInfo: T.func.isRequired,

  email: T.string.isRequired,
  firstName: T.string.isRequired,
  lastName: T.string.isRequired,
  loading: T.bool.isRequired,
};

export default UserFormCard;
